import "./Buttons.css";

function Buttons({ firstText, secondText, color = false, firstClicked, secondClicked }) {
    function firstButtonClasses() {
        let c = "explore-button";
        if (color) {
            c = `${c} button-color`;
        }
        return c;
    }
    return (
        <div className="button-section">
            <button className={firstButtonClasses()} onClick={firstClicked}>
                {firstText}
            </button>
            <button className="book-button" onClick={secondClicked}>
                {secondText}
            </button>
        </div>
    );

}

export default Buttons;